import { FabricImage, IText, Rect, Circle, Line, Group, Shadow, Path } from "fabric";

// Curved text: the text runs along an invisible arc. curve -100..100 (negative = smile, positive = rainbow).
export function curvePath(o, curve) {
  o.set({ path: null }); o.initDimensions();
  if (!curve) return null;
  const L = o.width, th = Math.max(0.15, (Math.abs(curve) / 100) * Math.PI * 1.6), r = L / th, h = th / 2;
  const x = r * Math.sin(h), y = r * Math.cos(h), big = th > Math.PI ? 1 : 0;
  const d = curve > 0 ? `M ${-x} ${-y} A ${r} ${r} 0 ${big} 1 ${x} ${-y}` : `M ${-x} ${y} A ${r} ${r} 0 ${big} 0 ${x} ${y}`;
  return new Path(d, { visible: false, fill: "", stroke: "" });
}

const BASE = { left: 60, top: 60 };
export const CUSTOM_PROPS = ["mock", "mockData", "name", "adj", "curve", "grad", "origSrc", "fullSrc", "cropBox"];

export const makeText = () => new IText("Double-click to edit", { ...BASE, fontFamily: "Arial", fontSize: 28, fill: "#222736", strokeWidth: 0 });
export const makeHeading = () => new IText("+ ADD NEW CLIENT", {
  ...BASE, fontFamily: "Montserrat", fontWeight: 900, fontSize: 48, fill: "#8bc34a", stroke: "#0b3d0b", strokeWidth: 1.5, paintFirst: "stroke",
  shadow: new Shadow({ color: "rgba(0,0,0,0.45)", blur: 6, offsetX: 3, offsetY: 3 }),
});
export const makeRect = () => new Rect({ ...BASE, width: 240, height: 140, fill: "#21a6ec", stroke: "", strokeWidth: 0 });
export const makeRounded = () => new Rect({ ...BASE, width: 420, height: 300, rx: 24, ry: 24, fill: "#222736", stroke: "", strokeWidth: 0 });
export const makeCircle = () => new Circle({ ...BASE, radius: 70, fill: "#f4b400", stroke: "", strokeWidth: 0 });
export const makeLine = () => new Line([60, 60, 360, 60], { stroke: "#1f4e86", strokeWidth: 4 });

export async function makeImage(url, maxW = 400, maxH = 10000) {
  const img = await FabricImage.fromURL(url, { crossOrigin: "anonymous" });
  const s = Math.min(1, maxW / (img.width || maxW), maxH / (img.height || maxH));
  img.set({ ...BASE, scaleX: s, scaleY: s });
  return img;
}

// Mock-up form pieces (grouped). mockData keeps the settings so the piece is rebuilt crisp after resize / text edit.
const MOCK_DEFAULTS = {
  field: { w: 300, h: 26, text: "", fill: "#ffffff", color: "#9e9e9e" },
  dropdown: { w: 300, h: 26, text: "Select…", fill: "#ffffff", color: "#9e9e9e" },
  button: { w: 130, h: 30, text: "New Work Order", fill: "#0b6623", color: "#ffffff" },
  tick: { w: 18, h: 18, text: "", fill: "#ffffff", color: "#000000" },
};
export const MOCK_LABELS = { field: "Field box", dropdown: "Dropdown", button: "Button", tick: "Tick box" };

export function makeMock(type, over = {}) {
  const btn = type === "button";
  const d = { stroke: btn ? "#000000" : "", sw: btn ? 1 : 0, font: "Arial", shadow: false, ...MOCK_DEFAULTS[type], ...over, type };
  // box grows to fit a bigger font and shrinks back to its own height (bh) when the font gets smaller
  d.bh = d.bh || d.h;
  if (type !== "tick") d.h = d.fs ? Math.max(d.bh, Math.round(d.fs * 1.5)) : d.bh;
  const rect = new Rect({ left: 0, top: 0, width: d.w, height: d.h, rx: type === "tick" ? 3 : 6, ry: type === "tick" ? 3 : 6, fill: d.fill,
    stroke: d.sw ? d.stroke || "#000000" : "", strokeWidth: d.sw || 0, shadow: d.shadow ? new Shadow({ color: "rgba(0,0,0,0.4)", blur: 6, offsetX: 2, offsetY: 2 }) : null });
  const parts = [rect];
  const fs = d.fs || Math.max(9, Math.min(15, d.h * 0.5)), ty = (d.h - fs * 1.16) / 2;
  // keep long wording inside the box: trim it with "…" (the full wording stays in the panel box)
  const clip = (t, room) => { const full = t.text; let n = full.length; while (n > 1 && t.width > room) { n -= 1; t.set({ text: full.slice(0, n).trimEnd() + "…" }); t.initDimensions(); } return t; };
  const font = { fontSize: fs, fontFamily: d.font, fontWeight: (d.bold ?? btn) ? "bold" : "normal", fill: d.color, strokeWidth: 0 };
  if (btn) { const t = clip(new IText(d.text || " ", { ...font, top: ty }), d.w - 10); t.set({ left: (d.w - t.width) / 2 }); parts.push(t); }
  else if (type !== "tick") {
    const v = type === "dropdown" && new IText("V", { top: ty, fontSize: fs, fontWeight: "bold", fontFamily: "Arial", fill: "#000000", strokeWidth: 0 });
    if (v) v.set({ left: d.w - v.width - 6 });
    parts.push(clip(new IText(d.text || " ", { ...font, left: 9, top: ty }), d.w - (v ? v.width + 21 : 16)));
    if (v) parts.push(v);
  }
  const g = new Group(parts, { left: over.left ?? BASE.left, top: over.top ?? BASE.top, angle: over.angle || 0, opacity: over.opacity ?? 1, subTargetCheck: false });
  g.mock = type;
  g.mockData = d;
  return g;
}
